import jsPDF from 'jspdf'

//import propostas from './propostas'
import moment from 'moment'


var pdfDoc = {
  startX: 20,
  startY: 30,
  project: {},

  async createPdf(pages, images, project, enterprise, formula0) {
    this.project = project;
    var profile = enterprise.quoteProfiles[project.site.solarRequest.quoteProfileId];
    var formula = profile.formulaDocument.script;
    var images = profile.formulaDocument.images;

    let pdfName = 'Proposta';

    var doc = new jsPDF();

    var imagesUrl = [];
    for (var i = 0; i < images.length; i++) {
      var imageUrl = await this.getBaseUrl(images[i].url)
      imagesUrl.push(imageUrl);
    }


    var startX = this.startX + 5;
    var startY = this.startY;
    var x = this.startX + 5;
    var y = this.startY;
    y += 37;
    var d = new Date();
    var rows = [];
    var s;
    var phasesDescription;
    var collumns;
    var r;
    var a;
    var c = 0;
    var tableWidth;
    var rowHeight;
    var i;
    var area;
    var accAnnualProduction = [];
    var acc;
    var labels;
    var values;
    var totalSavings=0;
    var split;
    var warrantyModules = Infinity;
    var warrantyInverters = Infinity;
    var warrantyStructures = Infinity;
    

    const insertTable = function (doc, startX, startY, collumns, rows , _rowHeight) {
      doc.setDrawColor(200, 200, 200); // draw red lines
      var y = startY;
      var x = startX;
      var a = 0;
      var c = 0;
      var tableWidth = 160;
      var rowHeight = 8.7;
      if(_rowHeight)
        rowHeight = _rowHeight;

      var r;
      doc.setDrawColor(16, 159, 147);// draw red lines
      while (a < rows.length) {
        var i = a % 2;
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        if (a == 0) {
          doc.setFillColor(16, 159, 147)
          doc.setTextColor(0, 0, 0);
        }
        for (c = 0; c < collumns.length; c++) {
          doc.text(startX + collumns[c] + 3, y + 5, rows[a][c].toUpperCase())
        }
        a++;
        y += rowHeight;
      }
    };

    const insertTable1 = function (doc, startX, startY, collumns, rows, _rowHeight) {
      doc.setDrawColor(200, 200, 200); // draw red lines
      var y = startY;
      var x = startX;
      var a = 0;
      var c = 0;
      var tableWidth = 160;
      var rowHeight = 8;
      if(_rowHeight)
        rowHeight = _rowHeight;
      doc.setDrawColor(0, 0, 0);// draw red lines
      while (a < rows.length) {
        var i = a % 2;
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        for (c = 0; c < collumns.length; c++) {
          doc.text(startX + collumns[c] + 3, y + 5, rows[a][c])
        }
        a++;
        y += rowHeight;
      }
    };


    const insertTable2 = function (doc, startX, startY, collumns, rows,_rowHeight ) {
      doc.setDrawColor(200, 200, 200); // draw red lines
      var y = startY;
      var x = startX;
      var a = 0;
      var c = 0;
      var tableWidth = 160;
      var rowHeight = 8.7;
      if(_rowHeight)
        rowHeight = _rowHeight;
      doc.setFontSize(7);
      var r;
      doc.setDrawColor(16, 159, 147);// draw red lines
      while (a < rows.length) {
        var i = a % 2;
     
        doc.setTextColor(0, 0, 0);
        if (a == 0) {
          doc.setFillColor(16, 159, 147)
          doc.setTextColor(255, 255, 255);
          doc.rect(x, y, tableWidth, rowHeight, 'F'); // filled up square
        } else {
          doc.rect(x, y, tableWidth, rowHeight); // empty square
        }
        //doc.line(x , y, x + tableWidth,  y );
        for (c = 0; c < collumns.length; c++) {
          doc.text(startX + collumns[c] + 3, y + 5, rows[a][c].toUpperCase())
        }
        a++;
        y += rowHeight;
      }
      doc.line(x, startY + rows.length * rowHeight, x + tableWidth, startY + rows.length * rowHeight);
      doc.line(x, startY, x, startY + rows.length * rowHeight);
      for (c = 0; c < collumns.length; c++)
        doc.line(x + collumns[c], startY, x + collumns[c], startY + rows.length * rowHeight);
      doc.line(x + tableWidth, startY, x + tableWidth, startY + rows.length * rowHeight);
    };

    const insertTable3 = function (doc, startX, startY, collumns, rows,_rowHeight, _tableWidth ) {
      doc.setDrawColor(200, 200, 200); // draw red lines //(244,243,244)
      var y = startY;
      var x = startX;
      var a = 0;
      var c = 0;
      var tableWidth = 160;
      var rowHeight = 8.7;
      if(_rowHeight)
        rowHeight = _rowHeight;
      if(_tableWidth)
        tableWidth = _tableWidth;
      doc.setFontSize(7);
      var r;
         doc.setFillColor(244,243,244);
         
      while (a < rows.length) {
        var i = a % 2;
     
        doc.setTextColor(0, 0, 0);
        if (a == 0) {
            doc.setFillColor(255,255,255);
            doc.setTextColor(0, 0, 0);
            doc.rect(x, y, tableWidth, rowHeight, 'FD'); // filled up square
        } else {
          if(i){
            doc.setFillColor(244,243,244);
            doc.rect(x, y, tableWidth, rowHeight , 'F'); //filled up square

          }
          else{
            doc.setFillColor(244,243,244);
            doc.rect(x, y, tableWidth, rowHeight); // empty square

          }
         
        }
        //doc.line(x , y, x + tableWidth,  y );
        for (c = 0; c < collumns.length; c++) {
          doc.text(startX + collumns[c] + 3, y + 5, rows[a][c].toUpperCase())
        }
        a++;
        y += rowHeight;
      }
      doc.line(x, startY + rows.length * rowHeight, x + tableWidth, startY + rows.length * rowHeight);
      doc.line(x, startY, x, startY + rows.length * rowHeight);
      for (c = 0; c < collumns.length; c++)
        doc.line(x + collumns[c], startY, x + collumns[c], startY + rows.length * rowHeight);
      doc.line(x + tableWidth, startY, x + tableWidth, startY + rows.length * rowHeight);
    };
    const formatDate = function (value) {
      return moment(value).format('DD/MM/YYYY');
    };

    const formatReais = function (value) {
      var r = new Intl.NumberFormat('pt-BR', {
        currency: "BRL",
        style: "currency",
        minimumFractionDigits: 2
      }).format(value || 0);
      return r;
    };
    const formatDecimal = function (value) {
      var d = Math.round(value * 100) / 100
      var r = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(d || 0)
      return r;
    };
    const formatkWh = function (valor) {
      return parseFloat(valor).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " kWh";
    };

    const insertText = function (doc, text, fontSize, x, y,color) {
      var split = doc.splitTextToSize(text, 245 * fontSize / 8);
      doc.setFontSize(fontSize);
      doc.setTextColor(0, 0, 0);

      if(color)
        doc.setTextColor(color.r, color.g,color.b);
      doc.text(x, y, split);

    };


    const insertChart = function (doc, x, y, width, height, labels, values, unidade, inclinacaoLabel) {
      if (values[0] == 0)
        return

      doc.setLineWidth(0.2);
      var graf_xPos = x;
      var graf_yPos = y;
      var graf_Height = height; //Altura do grafico
      var graf_Width = width;
      var xW = graf_Width / values.length; //
      var xM = 2.0;
      var yMargem = 4.0;
      var gBottom = yMargem + graf_yPos + graf_Height; //Ponto minimo do grafico

      //Inicializar
      var maxY = 0.0;
      var minY = 0.0;

      //Encontrar valor maximo
      for (var a = 0; a < values.length; a++) {
        if (values[a] > maxY)
          maxY = parseFloat(values[a]);
        if (values[a] < minY)
          minY = parseFloat(values[a]);
      }


      //Chart initialisation
      var yRange = maxY - minY;

      var yZero = gBottom - yMargem - (graf_Height / yRange) * (Math.abs(minY));
      var xZero = graf_xPos;

      var yLower = gBottom - yMargem;

      //Print y Labels

      var yLabels = [minY, 0, maxY / 2, maxY];


      //Linhas verticais  
      for (var a = 0; a <= values.length; a++) {
        var xPos = graf_xPos + a * xW;
        doc.setDrawColor(220, 220, 220); // draw red lines
        doc.line(xPos, graf_yPos, xPos, graf_yPos + graf_Height);
      }

      //Linhas horizontais
      for (var a = 0; a < yLabels.length; a++) {
        var xFinal = values.length * xW;
        var yPos = (yLabels[a]) * graf_Height / yRange;
        doc.setDrawColor(220, 220, 220); // draw red lines
        doc.line(graf_xPos, yZero - yPos, graf_xPos + xFinal, yZero - yPos);
      }


      console.log("Grafico OK")

      //Bars  
      for (var a = 0; a < values.length; a++) {
        // var yPos = (values[a])*graf_Height/yRange + yZero;
        var xPos = a * xW;

        if (values[a] > 0) {
          var yPos = (values[a]) * graf_Height / yRange;
          var height = Math.abs(values[a] * graf_Height / yRange);
          //doc.setFillColor(21, 129, 106);
          //doc.setFillColor(126, 223, 157);
          //doc.setFillColor(80,165,85);
          doc.setFillColor(16, 159, 147);

          doc.rect(graf_xPos + xPos + xW / 4, yZero - yPos, xW / 2, height, 'F');

        } else {
          var yPos = (values[a]) * graf_Height / yRange;
          var height = Math.abs(values[a] * graf_Height / yRange);
          doc.setFillColor(204, 0, 0);
          doc.rect(graf_xPos + xPos + xW / 4, yZero, xW / 2, height, 'F');
        }
        doc.setFontSize(8);
        // filled square
      }
      // Y labels
      for (var a = 0; a < yLabels.length; a++) {
        var xPos = a * xW;
        var yPos = yLabels[a] * graf_Height / yRange;
        doc.setTextColor(100, 100, 100);
        doc.setFontSize(8);
        if (unidade == "R$")
          if (a != 1)
            doc.text(graf_xPos - 23.0, yZero - yPos + 2, formatReais(yLabels[a]));
        if (unidade == "kWh")

          doc.text(graf_xPos - 23.0, yZero - yPos + 2, formatkWh(yLabels[a]));
        if (unidade == "k") {
          if (a != 1)
            doc.text(graf_xPos - 10, yZero - yPos + 2, (yLabels[a] / 1000).toFixed(0) + "k");
        }

      }
      //X labels
      for (var a = 0; a < labels.length; a++) {
        var xPos = graf_xPos + a * xW;
        doc.setTextColor(100, 100, 100);
        doc.setFontSize(8);
        
        if(inclinacaoLabel)
          doc.text(xPos + xW / 4, gBottom + 3, labels[a].toString() ,inclinacaoLabel )  ;
        else
          doc.text(xPos + xW / 4, gBottom +3 , labels[a].toString()  )  ;
        
      }
    };
    const insertChartBaden = function (doc, x, y, width, height, labels, values, unidade) {
      if (values[0] == 0)
        return

      doc.setLineWidth(0.2);
      var graf_xPos = x;
      var graf_yPos = y;
      var graf_Height = height; //Altura do grafico
      var graf_Width = width;
      var xW = graf_Width / values.length; //
      var xM = 2.0;
      var yMargem = 4.0;
      var gBottom = yMargem + graf_yPos + graf_Height; //Ponto minimo do grafico

      //Inicializar
      var maxY = 0.0;
      var minY = 0.0;

      //Encontrar valor maximo
      for (var a = 0; a < values.length; a++) {
        if (values[a] > maxY)
          maxY = parseFloat(values[a]);
        if (values[a] < minY)
          minY = parseFloat(values[a]);
      }


      //Chart initialisation
      var yRange = maxY - minY;

      var yZero = gBottom - yMargem - (graf_Height / yRange) * (Math.abs(minY));
      var xZero = graf_xPos;

      var yLower = gBottom - yMargem;

      //Print y Labels

      var yLabels = [minY, 0, maxY / 2, maxY];


      //Linhas verticais  
      for (var a = 0; a <= values.length; a++) {
        var xPos = graf_xPos + a * xW;
        doc.setDrawColor(220, 220, 220); // draw red lines
        doc.line(xPos, graf_yPos, xPos, graf_yPos + graf_Height);
      }

      //Linhas horizontais
      for (var a = 0; a < yLabels.length; a++) {
        var xFinal = values.length * xW;
        var yPos = (yLabels[a]) * graf_Height / yRange;
        doc.setDrawColor(220, 220, 220); // draw red lines
        doc.line(graf_xPos, yZero - yPos, graf_xPos + xFinal, yZero - yPos);
      }


      console.log("Grafico OK")

      //Bars  
      for (var a = 0; a < values.length; a++) {
        // var yPos = (values[a])*graf_Height/yRange + yZero;
        var xPos = a * xW;

        if (values[a] > 0) {
          var yPos = (values[a]) * graf_Height / yRange;
          var height = Math.abs(values[a] * graf_Height / yRange);
          //doc.setFillColor(21, 129, 106);
          //doc.setFillColor(126, 223, 157);
          //doc.setFillColor(80,165,85);
          //RGB (255,199,97)
          doc.setFillColor(255,199,97);
          //doc.setFillColor(16, 159, 147);

          doc.rect(graf_xPos + xPos + xW / 4, yZero - yPos, xW / 2, height, 'F');

        } else {
          var yPos = (values[a]) * graf_Height / yRange;
          var height = Math.abs(values[a] * graf_Height / yRange);
          doc.setFillColor(204, 0, 0);
          doc.rect(graf_xPos + xPos + xW / 4, yZero, xW / 2, height, 'F');
        }
        doc.setFontSize(8);
        // filled square
      }
      // Y labels
      for (var a = 0; a < yLabels.length; a++) {
        var xPos = a * xW;
        var yPos = yLabels[a] * graf_Height / yRange;
        doc.setTextColor(100, 100, 100);
        doc.setFontSize(8);
        if (unidade == "R$")
          if (a != 1)
            doc.text(graf_xPos - 23.0, yZero - yPos + 2, formatReais(yLabels[a]));
        if (unidade == "kWh")

          doc.text(graf_xPos - 23.0, yZero - yPos + 2, formatkWh(yLabels[a]));
        if (unidade == "k") {
          if (a != 1)
            doc.text(graf_xPos - 10, yZero - yPos + 2, (yLabels[a] / 1000).toFixed(0) + "k");
        }

      }
      //X labels
      for (var a = 0; a < labels.length; a++) {
        var xPos = graf_xPos + a * xW;
        doc.setTextColor(100, 100, 100);
        doc.setFontSize(8);
        doc.text(xPos + xW / 4, gBottom+3, labels[a].toString(),null, 45);
      }
    };

    var  paymentTermsOptions= {
        "-1" : "Não selecionado",
        "0" : "Antecipado",
        "1" : "À vista" ,
        "2": "Editável" 
    } 
  
    var deliveryDaysOptions = {
      "-1" : "Não selecionado" ,
      "999" :"A combinar" ,
      "30" : "Até 30 dias" ,
      "60" : "Até 60 dias" ,
      "90" : "Até 90 dias" ,
      "120" : "Até 120 dias" ,
    };

  
    

    var f = formula.replaceAll("\n", "");
    console.log(f);
    eval(f);

  },


  async getBaseUrl(url) {
    var c = await fetch(url, {
      method: 'GET',

    })
      .then((res) => {
        console.log("first ans")
        console.log(res);

        return res.blob();
      })
      .then((blob) => {
        return blob;

      });
    var x = await this.readFileAsync(c);
    return x;
  },

  async readFileAsync(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      //reader.readAsArrayBuffer(file);
      reader.readAsDataURL(file)

    })
  },



};
export default pdfDoc;


